import React, { Component } from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";

import ContentHeader from "./ContentHeader";
import { list, create, update } from "../actions";
import Table from "../utils/table";
import { SLBTxtBox } from "../utils/Forms";
import {
  editNoticeCategory,
  newNoticeCategory
} from "../actions/noticeCategories";

class NoticeCategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeCategory: {},
      errors: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.setNoticeCategory();
  }

  componentWillReceiveProps(nextProps) {
    this.setNoticeCategory(nextProps.currentNoticeCategory);
  }

  setNoticeCategory(data = {}) {
    const noticeCategory = {
      name: data.name || "",
      id: data.id || 0
    };
    this.setState({ noticeCategory });
  }

  clearForm() {
    this.props.newNoticeCategory();
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    let newNoticeCategory = { ...this.state.noticeCategory, [name]: value };
    this.setState({ ...this.state, noticeCategory: newNoticeCategory });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isNoticeCategoryValid(this.state.noticeCategory)) {
      this.props.saveNoticeCategory(this.state.noticeCategory);
    }
  }

  isNoticeCategoryValid(noticeCategory = {}) {
    let errors = {};
    if (isEmpty(noticeCategory.name)) {
      errors["name"] = "Name is required!";
    }
    this.setState({ errors });
    return isEmpty(errors);
  }

  render() {
    let { name, id } = this.state.noticeCategory;
    const { errors } = this.state;
    let mode = id > 0 ? "Edit" : "New";
    let buttonText = id > 0 ? "Update" : "Create";

    const title = `${mode} Category`;
    return (
      <div>
        <ContentHeader title={title}>
          <span className="pull-right" />
        </ContentHeader>
        <form onSubmit={this.handleSubmit}>
          <div className="clearfix">
            <div className="row">
              <SLBTxtBox
                label="Name"
                name="name"
                value={name}
                context={this}
                attrs={{ errors, klass: "col-md-12" }}
              />
            </div>
            <br />
            <div className="col-md-12 edit-buttons-pane">
              <input
                className="btn btn-success pull-right"
                type="submit"
                value={buttonText}
              />
              <a
                className="btn btn-default pull-right"
                style={{ marginRight: 10 }}
                onClick={this.clearForm}
              >
                Cancel
              </a>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

class NoticeCategoriesList extends Component {
  render() {
    let {
      noticeCategories,
      loading,
      handleEvent
    } = this.props;

    const tableFields = [
      { name: "name", header: "Name" },
      { name: "edit", type: "action", header: "", action: "editNoticeCategory" }
    ];

    let content;
    if (loading) {
      content = (
        <div className="zero-items">
          <p> Fetching noticeCategories, please wait ... </p>
        </div>
      );
    } else {
      content = <div className="zero-items" />;
    }

    let columnWrappers = {
      view(f) {
        return (
          <span>
            {" "}<i className="fa fa-eye"> </i>{" "}
          </span>
        );
      },
      edit(f) {
        return (
          <span>
            {" "}<i className="fa fa-pencil"> </i>{" "}
          </span>
        );
      }
    };

    if (noticeCategories.length !== 0) {
      content = (
        <div>
          <Table
            tableData={noticeCategories}
            tableFields={tableFields}
            handleEvent={handleEvent}
            columnWrappers={columnWrappers}
          />
          <div />
        </div>
      );
    }

    return (
      <div>
        <ContentHeader title="Categories">
          <span className="pull-right" />
        </ContentHeader>
        <div>
          {content}
        </div>
      </div>
    );
  }
}

class NoticeCategories extends Component {
  componentDidMount() {
    this.props.fetchNoticeCategories();
    this.handleTableAction = this.handleTableAction.bind(this);
  }

  handleTableAction(eventName, data) {
    this[eventName](data);
  }

  editNoticeCategory(noticeCategory) {
    this.props.editNoticeCategory(noticeCategory);
  }
  render() {
    let { noticeCategory, saveNoticeCategory, newNoticeCategory } = this.props;
    return (
      <div className="slb-tab-content">
        <div className="col-md-8">
          <NoticeCategoriesList
            handleEvent={this.handleTableAction}
            noticeCategories={this.props.noticeCategories}
          />
        </div>
        <div className="col-md-4">
          <NoticeCategoryForm
            noticeCategory={noticeCategory}
            saveNoticeCategory={saveNoticeCategory}
            newNoticeCategory={newNoticeCategory}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { currentNoticeCategory, list } = state.noticeCategories;
  return {
    noticeCategories: list,
    currentNoticeCategory: currentNoticeCategory
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchNoticeCategories() {
      dispatch(list("noticeCategories"));
    },
    newNoticeCategory() {
      dispatch(newNoticeCategory());
    },
    editNoticeCategory(noticeCategory) {
      dispatch(editNoticeCategory(noticeCategory));
    },
    saveNoticeCategory(data) {
      if (data.id) {
        dispatch(update("noticeCategory", data));
      } else {
        dispatch(create("noticeCategory", data));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoticeCategories);



// WEBPACK FOOTER //
// ./src/components/NoticeCategories.js